import React from "react";
import "./contacts.less";
import ContactsTable from "./contactsTable";
import { routes } from "../../../constants/routes";

class Contacts extends React.Component {
  constructor(props) {
    super(props);
    const { location } = props;
    this.state = {
      selectedTenantId: location.aboutProps ? location.aboutProps.TenantId : "",
      selectedTenantName: location.aboutProps
        ? location.aboutProps.TenantName
        : "",
      selectedPropertyId:location.aboutProps ? location.aboutProps.PropertyId : 0,
      isAddDialogOpen: location.aboutProps && location.aboutProps.isOpenDefaultAdd && location.aboutProps.isActiveTenant ? location.aboutProps.isOpenDefaultAdd : false,
      isDisabledAdd: location.aboutProps && location.aboutProps.isActiveTenant !== undefined ? !location.aboutProps.isActiveTenant : false,
      tenantEffectiveToDate: location.aboutProps && location.aboutProps.tenantEffectiveToDate
    };
  }

  componentDidMount() {
    const { selectedTenantId } = this.state;
    if (!selectedTenantId) {
      this.props.history.push(routes.tenants);
    }
  }


  /**
   * call on back button
   */
  backToTenant = () => {
   
    this.props.history.push({pathname:routes.tenants,appState:{colFilteredObj: JSON.parse(localStorage.getItem("colObj")),selectedIds:JSON.parse(localStorage.getItem("selectedIds"))}});
  };

  render() {
    const { selectedTenantId, selectedTenantName, isAddDialogOpen, selectedPropertyId, isDisabledAdd, tenantEffectiveToDate } = this.state;

    return (
      <div className={"mainContactPage"}>
        <div className={"row"}>
          <div className={"tenants-contact-wrapper"}>
            <div className={"tenants-contact-breadcrumb-wrapper"}>
              <span className={"tenants-contact-breadcrumb"}>
               {"HOME | Tenant "}{">"} {selectedTenantName} {"| Contacts\r"}
              </span>
            </div>
          </div>
        </div>
        <div className={"row tenant-contact-table"}>
          <ContactsTable
            selectedTenantId={selectedTenantId}
            selectedTenantName={selectedTenantName}
            selectedPropertyId={selectedPropertyId}
            backToTenant={this.backToTenant}
            isAddDialogOpen={isAddDialogOpen}
            isDisabledAdd={isDisabledAdd}
            tenantEffectiveToDate={tenantEffectiveToDate}
          />
        </div>
      </div>
    );
  }
}
export default Contacts;
